import type * as React from "react"

import type { ActivityMessageHistoryProps } from "./activity-message/activity-message-history"
import type { ChatContentProps } from "./chat-content"
import type { ChatFooterProps } from "./chat-footer"
import type { ChatHeaderProps } from "./chat-header"
import type { ErrorProps } from "./error"
import type { ExampleQuestionsProps } from "./example-question"
import type { LoadingProps } from "./loading"
import type { SystemMessageProps } from "./system-message"
import type { UserMessageProps } from "./user-message"

import { ActivityMessageHistory } from "./activity-message/activity-message-history"
import { ChatContent } from "./chat-content"
import { ChatFooter } from "./chat-footer"
import { ChatHeader } from "./chat-header"
import { Error } from "./error"
import { ExampleQuestions } from "./example-question"
import { Loading } from "./loading"
import { SystemMessage } from "./system-message"
import { UserMessage } from "./user-message"

type BaseChatProps = React.HTMLAttributes<HTMLDivElement> & {
  children: React.ReactNode
}

/* eslint-disable react/function-component-definition -- Compound component pattern requires arrow function */
const Chat: React.FC<BaseChatProps> & {
  Header: React.FC<ChatHeaderProps>
  Content: React.FC<ChatContentProps>
  UserMessage: React.FC<UserMessageProps>
  SystemMessage: React.ComponentType<SystemMessageProps>
  Loading: React.FC<LoadingProps>
  Error: React.FC<ErrorProps>
  ExampleQuestions: React.FC<ExampleQuestionsProps>
  Footer: React.FC<ChatFooterProps>
  ActivityMessageHistory: React.FC<ActivityMessageHistoryProps>
} = ({ children, ...props }) => {
  // If no props besides children, just render children directly
  if (Object.keys(props).length === 0) {
    return children
  }
  // Otherwise wrap in a div to pass through props like data-testid
  return <div {...props}>{children}</div>
}
/* eslint-enable react/function-component-definition */

Chat.Header = ChatHeader
Chat.Content = ChatContent
Chat.SystemMessage = SystemMessage
Chat.UserMessage = UserMessage
Chat.ExampleQuestions = ExampleQuestions
Chat.Loading = Loading
Chat.Error = Error
Chat.Footer = ChatFooter
Chat.ActivityMessageHistory = ActivityMessageHistory

export { Chat }
